<script>
	import SvelteFa from "$lib/components/SvelteFa.svelte";
	import { faCircleMinus } from "@fortawesome/free-solid-svg-icons";
	import { slugify } from "cando-util";
	import { getSupportedLanguagesAry } from "$lib/utilities/translate";

	import { store } from "$lib/utilities/store";

	import Select from "$lib/components/Select.svelte";
	import Textarea from "$lib/components/Textarea.svelte";
	import TextInput from "$lib/components/TextInput.svelte";
	import DateInput from "$lib/components/DateInput.svelte";
	import ImageFile from "$lib/components/ImageFile.svelte";
	import IconSelect from "$lib/components/IconSelect.svelte";
	import TextObject from "$lib/components/TextObject.svelte";
	import RunFunction from "./RunFunction.svelte";
	import UpdateTranslation from "./UpdateTranslation.svelte";

	export let col;
	export let settingId;
	export let fld;
	export let handleChange = () => {};
	export let lang;
	export let showKey = true;
	export let editMode = true;

	let supportedLanguagesAry = [];
	$: (() => {
		const { supportedLanguagesAry: ary } = getSupportedLanguagesAry(
			$store?.settings?.docs?.languages,
		);
		supportedLanguagesAry = ary;
	})();

	$: translationCount = Object.keys(
		$store?.[col]?.docs?.[settingId]?.[fld.key]?.translations || {},
	).length;

	$: txtObjTranslationCount = Object.entries(
		$store?.[col]?.docs?.[settingId]?.[fld.key]?.value || {},
	).reduce((a, [k, v]) => a + Object.keys(v?.translations || {}).length, 0);
	$: requiredTxtObjTranslationCount =
		Object.keys($store?.[col]?.docs?.[settingId]?.[fld.key]?.value || {})
			.length * supportedLanguagesAry.length;
</script>

<div class="w-full flex justify-between gap-2">
	{#if showKey}
		<label for={`${slugify(fld.key)}-input`} class="font-semibold w-72">
			<div class="text-lg bg-base-300 p-2">
				{`${fld.key}:`}
			</div>
		</label>
	{/if}
	<div class="flex justify-between w-full">
		<div class="w-full">
			{#if fld.type === "TextInput"}
				{#if lang}
					lang:{lang}
					{#if $store?.[col]?.docs?.[settingId]?.[fld.key]?.translations?.[lang]}
						<TextInput
							bind:value={
								$store[col].docs[settingId][fld.key]
									.translations[lang]
							}
							label={fld.key}
							key={fld.key}
							handleInputChange={handleChange}
							itemId={settingId}
							cls={"input input-bordered input-primary w-full"}
						/>
					{:else}
						<div>translation not available</div>
					{/if}
				{:else}
					<TextInput
						bind:value={$store[col].docs[settingId][fld.key].value}
						label={fld.key}
						key={fld.key}
						handleInputChange={handleChange}
						itemId={settingId}
						cls={"input input-bordered input-primary w-full"}
					/>
				{/if}
			{:else if fld.type === "TextArea"}
				{#if lang}
					lang:{lang}
					{#if $store?.[col]?.docs?.[settingId]?.[fld.key]?.translations?.[lang]}
						<Textarea
							label={fld.key}
							key={fld.key}
							bind:value={
								$store[col].docs[settingId][fld.key]
									.translations[lang]
							}
							handleInputChange={handleChange}
							itemId={settingId}
							additionalClass="font-mono"
						/>
					{:else}
						<div>translation not available</div>
					{/if}
				{:else}
					<Textarea
						label={fld.key}
						key={fld.key}
						bind:value={$store[col].docs[settingId][fld.key].value}
						handleInputChange={handleChange}
						itemId={settingId}
						additionalClass="font-mono"
					/>
				{/if}
			{:else if fld.type === "DateInput"}
				<DateInput
					key={fld.key}
					bind:value={$store[col].docs[settingId][fld.key].value}
					{handleChange}
					itemId={settingId}
				/>
			{:else if fld.type === "Image"}
				<div class="flex bg-base-100">
					<div class="flex gap-2 sm:gap-4 bg-base-100 p-2 sm:p-4">
						<ImageFile
							key={fld.key}
							path={`uploads/${col}/${settingId}/${fld.key}`}
							bind:image={
								$store[col].docs[settingId][fld.key].value
							}
							{handleChange}
							{lang}
							{col}
							itemId={settingId}
						/>
					</div>
				</div>
			{:else if fld.type === "Icon"}
				<IconSelect
					name={`Icon Select For ${col} ${settingId} ${fld.key}`}
					bind:icon={$store[col].docs[settingId][fld.key].value}
					key={fld.key}
					{handleChange}
					itemId={settingId}
				/>
			{/if}

			{#if fld.type === "TextObject"}
				<TextObject
					{col}
					{settingId}
					fld={fld.key}
					{handleChange}
					{lang}
					key={fld.key}
				/>
			{/if}
		</div>
	</div>

	<label for={`${slugify(fld.key)}-input`} class="flex font-semibold">
		{#if editMode}
			<div class="w-48">
				{#if $store.userRoles.admin}
					<div class="flex justify-between gap-2">
						<Select
							bind:value={
								$store[col].docs[settingId][fld.key].type
							}
							name="type"
							key={fld.key}
							options={[
								"TextInput",
								"TextArea",
								"DateInput",
								"Image",
								"Icon",
								"TextObject",
							]}
							{handleChange}
							itemId={settingId}
						/>
						<Select
							bind:value={
								$store[col].docs[settingId][fld.key].permission
							}
							name="permission"
							key={fld.key}
							options={["Admin", "Content"]}
							{handleChange}
							itemId={settingId}
						/>
					</div>
				{/if}
				{#if ["TextArea", "TextInput", "TextObject"].includes(fld.type)}
					{#if fld?.value?.functionName?.value !== undefined}
						<RunFunction fld={fld.key} {col} {settingId} />
					{/if}
					<UpdateTranslation key={fld.key} {col} {settingId} {lang} />
				{/if}
				{#if ["TextArea", "TextInput"].includes(fld.type)}
					<div class="flex w-full justify-between">
						<div>translations</div>
						<div
							class={translationCount ===
							supportedLanguagesAry.length
								? "text-green-400"
								: "text-red-400"}
						>
							{Object.keys(
								$store?.[col]?.docs?.[settingId]?.[fld.key]
									?.translations || {},
							).length}
						</div>
					</div>
				{/if}
				{#if ["TextObject"].includes(fld.type)}
					<div class="flex justify-between">
						<div>
							{`translations:`}
						</div>
						<div
							class={txtObjTranslationCount ===
							requiredTxtObjTranslationCount
								? "text-green-400"
								: "text-red-400"}
						>
							{txtObjTranslationCount}
							/
							{requiredTxtObjTranslationCount}
						</div>
					</div>
					<div class="max-h-60 overflow-scroll">
						{#each Object.entries($store?.[col]?.docs?.[settingId]?.[fld.key]?.value || {}).sort( (a, b) => (a[0] < b[0] ? -1 : 1), ) as entry}
							<div class="w-full flex justify-between">
								<div>
									{entry[0]}
								</div>
								<div
									class={Object.keys(
										entry[1]?.translations || {},
									).length === supportedLanguagesAry.length
										? "text-green-400"
										: "text-red-400"}
								>
									{Object.keys(entry[1]?.translations || {})
										.length}
								</div>
							</div>
						{/each}
					</div>
				{/if}
			</div>
		{/if}
		{#if $store.userRoles.admin && editMode}
			<div class="ml-2 sm:ml-4">
				<button
					id={`delete-${slugify(fld.key)}-button`}
					class="text-error"
					key={fld.key}
					itemId={settingId}
					on:click|preventDefault={(e) => {
						const n = $store[col].docs[settingId];
						delete n[fld.key];
						$store[col].docs[settingId] = { ...n };
						handleChange(e);
					}}
				>
					<SvelteFa icon={faCircleMinus} size="1.5x" />
				</button>
			</div>
		{/if}
	</label>
</div>
